import render from "@admin/root/render";

const root = (rootProps?: any, liveMode?: boolean) => ({
  defaultProps: {
    title: "",
    slug: "",
    settings: {
      description: "",
      alt_layout: false,
    },
  },
  render: (props: any) =>
    render({
      ...props,
      liveMode,
      rootProps,
    }),
});

export default root;
